"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DiningReportPageActions;
(function (DiningReportPageActions) {
    DiningReportPageActions["DataLoaded"] = "DataLoaded";
})(DiningReportPageActions || (DiningReportPageActions = {}));
exports.default = DiningReportPageActions;
